import MagstimTableTreatmentHistoryBase from './MagstimTableTreatmentHistoryBase';

class MagstimTableTreatmentHistory extends MagstimTableTreatmentHistoryBase {

}

export default MagstimTableTreatmentHistory;